import en from './en.json'
import it from './it.json'

export const callTranslations = {
	en,
	it
} as const
